import CityPageTemplate from "../city-template/CityPageTemplate";
import { erieCoConfig } from "./data";

export default function ErieCoPage() {
  return <CityPageTemplate config={erieCoConfig} />;
}